"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchResponse;
/**
 * 对后端返回数据的处理
 * @param {*} response
 */
function fetchResponse(response) {
  return new Promise(function (resolve, reject) {
    // 请求没成功
    if (!response.ok) {
      reject(response.statusText);
      return;
    }
    response.json().then(resolve, reject);
  });
}